module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"type": "object",
	"properties": {
		"target": {
			"type": "object",
			"properties": {
				"table": {
					"type": "string"
				},
				"column": {
					"type": "string"
				},
				"hierarchy": {
					"type": "string"
				},
				"hierarchyLevel": {
					"type": "string"
				},
				"measure": {
					"type": "string"
				}
			},
			"required": [
				"table"
			]
		},
		"operator": {
			"type": "string"
		},
		"values": {
			"type": "array",
			"items": {
				"type": [
					"string",
					"boolean",
					"number"
				]
			}
		}
	},
	"required": [
		"target",
		"operator",
		"values"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/schemas/basicFilter.json
 ** module id = 7
 ** module chunks = 0
 **/